import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { format } from 'date-fns'
import ShepherdLogo from '../../../assets/shepherdtech-logo.svg?react'
import { type Brand } from '../../../model/campaign'
import style from '../../../style/pages/client-closed.module.scss'

export const MerchantClosed = () => {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: activityInfo } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const brands = activityInfo?.brand_codes_info
  const startTime = activityInfo?.start_time ? format(new Date(activityInfo.start_time), 'yyyy/MM/dd') : ''
  const endTime = activityInfo?.end_time ? format(new Date(activityInfo.end_time), 'yyyy/MM/dd') : ''
  const hasDeadline = !!activityInfo?.end_time
  return (
    <main className={style.root}>
      <div className={style.content}>
        <Box mb={4}>
          <Text fontWeight={600} color="#4A5568">{activityInfo?.title}</Text>
          {hasDeadline && (
            <Text variant="caption" fontWeight={600} color="#4A5568">
              {startTime}
              -
              {endTime}
            </Text>
          )}
        </Box>
        <h1 className={style.title}>活動尚未開始，請至各品牌下單</h1>
        <div className={style.cards}>
          {Object.values(brands || {}).map((brand: Brand) => {
            return (
              <a href={brand.brand_url} key={brand.project_code} className={style.card}>
                <img className={style['card-img']} src={brand.brand_image} alt={brand.brand_name} />
              </a>
            )
          })}
        </div>
      </div>
      <div className={style.footer}>
        <p className={style.copyright}>
          Copyright © 2024 Shepherd Trading Limited., LTD. All rights reserved.
          {' '}
          <ShepherdLogo className={style['copyright-logo']} />
        </p>
      </div>
    </main>
  )
}
